export default __webpack_public_path__ + "static/media/3d-tiles-default.b5e8cf4c.webp";